export default (state = [], action) => {
 switch (action.type){  
   case 'GET_PAIRS':
    	return action.pairs
    default:
          return state;
  }
};